export class PostParams {
    //UserId: string;
    //Pass: string;
    //Dept: string;
    spKVs: string;
}

